<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div
                        v-for="(field, index) in fields"
                        :key="index"
                        :class="{
                            [field.class]: true,
                            'col-lg-12': field.type == 'heading',
                            'col-md-4':
                                field.type !== 'heading' && !field.class,
                            'col-md-8':
                                (index == 4 || index == 6) &&
                                section == 'account-info',
                        }"
                    >
                        <div
                            v-if="field.type == 'heading' && index > 0"
                            class="form-border"
                        ></div>

                        <component
                            :is="field.type"
                            :field="field"
                            :data-segment-id="dataSegmentId"
                        ></component>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-border"></div>
                    </div>
                </div>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="CONTINUE"
                    class="mr-3"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>
                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
                <!-- <b-button size="sm" variant="secondary" @click="$router.go(-1)">
                    Back
                </b-button> -->
            </div>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import OtherNationalities from '@/components/registration/OtherNationalities'

export default {
    /*
|--------------------------------------------------------------------------
| Component > components
|--------------------------------------------------------------------------
*/
    components: {
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
        OtherNationalities,
    }, // End of Component > components

    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {}, // End of Component > props

    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/
    data() {
        return {
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
            defaultFormData: {
                idenfoId: null,
                dataSegmentId: '5efeafb322adf8055ac38ca5',
                basicInfo: {
                    firstName: '{{FirstName}}',
                    fatherHusbandName: '',
                    middleName: '',
                    lastName: '',
                    genderId: '5efeafb322adf8055ac39557',
                    dateOfBirth: '{{DOB}}',
                    nationalityId: '{{Nat-id}}',
                    nationality: '{{Nationality}}',
                    countryOfResidenceId: '5efeafb322adf8055ac38db2',
                    countryOfResidence: 'Pakistan',
                },
                identityInfo: {
                    type: 'id',
                    number: '{{FathersName}}',
                    expiryDate: '2025-12-31',
                },
                occupationInfo: {
                    workTypeId: '5efeafb322adf8055ac38f04',
                    industryId: '5efeafb322adf8055ac38f04',
                    taxId: null,
                },
                contactInfo: {
                    address: '20th-22nd Floors, Centrepoint',
                    stateId: '5efeafb322adf8055ac39944',
                    city: 'Karachi',
                    postalCode: '74900',
                    isdCode: '+92',
                    phoneNumber: '999999999',
                    email: 'dummy@silkbank.com.pk',
                },
                accountInfo: {
                    purposeOfActionId: '5efeafb322adf8055ac39559',
                    products: [
                        {
                            productId: '5efeafb322adf8055ac38e06',
                            title: 'Current Account',
                            number: '12345',
                        },
                    ],
                    expectedCredit: '0',
                    creditLimit: '0',
                    grossIncome: '0',
                    initialBalance: '0',
                },
                documentInfo: {
                    utility: {
                        fileName: 'file-1599650356150.jpg',
                        originalFileName: 'file-1599650356150.jpg',
                    },
                    identity: {
                        originalFileName: 'file-1599652222696.jpg',
                        fileName: 'file-1599652222696.jpg',
                    },
                    video: {
                        fileName: 'file-1598259076206.mp4',
                        originalFileName: null,
                    },
                },
                customInfo: {},
            },
        }
    }, // End of Component > data

    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['loading', 'dataSegmentId', 'dataSegmentTypes']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > mounted

    /*
|--------------------------------------------------------------------------
| Component > watch
|--------------------------------------------------------------------------
*/
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
|--------------------------------------------------------------------------
| Component > mounted
|--------------------------------------------------------------------------
*/
    mounted() {
        this.getRecords()
        let routerName = this.$route.name
        // window.onpopstate = function(event) {
        //     alert("location: ");
        //     if (routerName == 'public-registration-setup-profile') {
        //          this.$router.push('/register-customer/investment')
        //     }
        // };
    }, // End of Component > computed

    /*
|--------------------------------------------------------------------------
| Component > methods
|--------------------------------------------------------------------------
*/
    methods: {
        validateAllCustom(formData) {
            // Issuance date should not be less than Date of Birth
            if (
                formData &&
                formData.identityInfo &&
                formData.identityInfo.IssuanceDate &&
                formData.basicInfo.dateOfBirth
            ) {
                if (
                    formData.basicInfo.dateOfBirth >
                    formData.identityInfo.IssuanceDate
                ) {
                    // const index = this.fields.findIndex((field) => {
                    //   if (field.label === 'Issuance Date') {
                    //     return true
                    //   }
                    // })
                    // // console.log("INDEX : " + index)
                    // this.fields[index]['isInvalid'] = true
                    return {
                        valid: false,
                        error: 'Issuance Date should not be less than Date of Birth',
                    }
                }
            }

            // Issuance Date earlier than expiry date
            if (
                formData &&
                formData.identityInfo &&
                formData.identityInfo.IssuanceDate &&
                formData.identityInfo.expiryDate
            ) {
                const result = this.earlierDateValidator(
                    formData.identityInfo.IssuanceDate,
                    'Issuance Date',
                    formData.identityInfo.expiryDate,
                    'Expiry Date'
                )
                if (result && result.valid) {
                    return result
                }
            }

            // Age should be greater than 18
            // if (formData.basicInfo && formData.basicInfo.dateOfBirth) {
            //     let TODAY = new Date(Date.now())
            //     let EIGHTEEN_YEARS_BACK = new Date(
            //         new Date(TODAY).getDate() +
            //             '/' +
            //             new Date(TODAY).getMonth() +
            //             '/' +
            //             (new Date(TODAY).getFullYear() - 18)
            //     )
            //     let result =
            //         EIGHTEEN_YEARS_BACK > formData.basicInfo.dateOfBirth

            //     if (!result) {
            //         const index = this.fields.findIndex((field) => {
            //             if (field.label === 'Date of Birth') {
            //                 return true
            //             }
            //         })
            //         if (index) {
            //             this.fields[index]['isInvalid'] = true
            //         }
            //         return {
            //             valid: false,
            //             error: 'Age should be greater than 18',
            //         }
            //     }
            // }
        },
        // Comparison between Dates Validation
        earlierDateValidator(
            earlierDate,
            earlierDateLabel,
            lateDate,
            lateDateLabel
        ) {
            if (earlierDate > lateDate) {
                // const index = this.fields.findIndex((field) => {
                //   if (field.label === "Issuance Date") {
                //     return true;
                //   }
                // });
                // // console.log("INDEX : " + index)
                // this.fields[index]["isInvalid"] = true;
                return {
                    valid: false,
                    error:
                        earlierDateLabel +
                        ' should be earlier than ' +
                        lateDateLabel,
                }
            }
        },
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // console.log(this.fields)
            // validate the form fields
            const result = await this.$validator.validateAll()
            // const result = true // Just for checking purpose.

            // Form State Data
            const data = this.$store.state.registration.form

            console.log('Default FormData : ', this.defaultFormData)

            // Setting FormData values

            this.defaultFormData.basicInfo.firstName = data.basicInfo.firstName
            this.defaultFormData.basicInfo.fatherHusbandName =
                data.basicInfo.fatherName
            this.defaultFormData.basicInfo.fatherName =
                data.basicInfo.fatherName
            this.defaultFormData.basicInfo.dateOfBirth =
                data.basicInfo.dateOfBirth
            this.defaultFormData.basicInfo.nationality =
                data.basicInfo.nationality
            this.defaultFormData.basicInfo.nationalityId =
                data.basicInfo.nationalityId
            this.defaultFormData.basicInfo.countryOfResidence =
                data.basicInfo.countryOfResidence
            this.defaultFormData.basicInfo.countryOfResidenceId =
                data.basicInfo.countryOfResidenceId
            this.defaultFormData.basicInfo.genderId = data.basicInfo.genderId
            this.defaultFormData.basicInfo.gender = data.basicInfo.gender
            this.defaultFormData.identityInfo.number = data.identityInfo.number

            // End Setting FormData values

            console.log('Default FormData : ', this.defaultFormData)

            console.log('Form Data : ', data)

            const resultCustom = this.validateAllCustom(data)

            // Check if validation fails
            if (result) {
                this.$store.commit('setLoading', true)

                let registrationUrl = '/customers/face-to-face'
                if (this.$route.meta.publicRegistration === true) {
                    registrationUrl = '/customers/non-face-to-face'
                }

                try {
                    const formData = this.defaultFormData
                    formData.dataSegmentId = this.dataSegmentId
                    formData.dataSegmentType = this.dataSegmentTypes

                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: formData,
                    })

                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })

                    if (this.$route.meta.publicRegistration === true) {
                        this.$router.push({
                            name: 'public-registration-finish',
                            params: {
                                dataSegmentId: this.dataSegmentId,
                                 dataSegmentType: this.dataSegmentTypes,
                            },
                        })
                    } else {
                        this.$router.push('/register-customer/finish')
                    }
                } catch (errors) {
                    this.$store.commit('setError', errors)
                }
                this.$store.commit('setLoading', false)

                /* 
                  
                  Below Code for Bank Alfalah AMC
                
                */

                //     if (resultCustom && !resultCustom.valid) {
                //         this.$store.commit('updateField', {
                //             key: 'forms.form2.valid',
                //             value: false,
                //         })
                //         this.$store.commit(
                //             'setError',
                //             resultCustom && resultCustom.error
                //                 ? resultCustom.error
                //                 : ''
                //         )
                //     } else {
                //         this.$store.commit('updateField', {
                //             key: 'forms.form2.valid',
                //             value: true,
                //         })
                //         console.log(
                //             'States:' +
                //                 JSON.stringify(this.$store.state.registration.form)
                //         )
                //         // this.$store.commit('setLoading', true)
                //         // if (this.restrictDuplicateCustomers) {
                //         //check customer nic if already exists with their data segment
                //         // let error = false
                //         // try {
                //         //     const params = {}
                //         //     params.dataSegmentId = this.dataSegmentId
                //         //     params.number =
                //         //         this.$store.state.registration.form.identityInfo.number
                //         //     const { data } = await request({
                //         //         url: '/customers/exists',
                //         //         method: 'get',
                //         //         params,
                //         //     })
                //         //     console.log('Exits: ', data)
                //         // } catch (e) {
                //         //     console.log('ExitsError: ', e)
                //         //     error = e
                //         // }
                //         // if (error) {
                //         //     this.$store.commit('setError', error)
                //         //     this.$store.commit('setLoading', false)
                //         //     return false
                //         // }
                //         /**
                //          * Pre Populate Fatca Info
                //          */
                //         this.$store.commit('updateField', {
                //             key: 'fatcaInfo.CNICNumber',
                //             value: this.$store.state.registration.form.identityInfo
                //                 .number,
                //         })
                //         this.$store.commit('updateField', {
                //             key: 'fatcaInfo.titleOfAcc',
                //             value: this.$store.state.registration.form.basicInfo
                //                 .firstName,
                //         })
                //         this.$store.commit('updateField', {
                //             key: 'fatcaInfo.placeOfBirth',
                //             value: this.$store.state.registration.form.basicInfo
                //                 .placeOfBirth,
                //         })
                //         /**
                //          * Pre Populate Fatca Info End
                //          */
                //         if (this.$route.meta.publicRegistration === true) {
                //             this.$router.push({
                //                 name: 'public-registration-account-info',
                //                 params: {
                //                     dataSegmentId: this.dataSegmentId,
                //                 },
                //             })
                //         } else {
                //             this.$router.push('/register-customer/account-info')
                //         }
                //     }
                // }

                /* 
                  
                  End Code for Bank Alfalah AMC
                
                */
            } else {
                // this.$store.commit('updateField', {
                //     key: 'forms.form2.valid',
                //     value: false,
                // })
                this.$store.commit('setError', this.errors.all()[0])
            }
        },

        /**
         * checkIBAN
         */
        checkIBAN() {
            // Check of IBAN length
            try {
                let ibanLength =
                    this.$store.state.registration.form.accountInfo
                        .internationalBankAccountNumberIban.length
                if (ibanLength === 24) {
                    console.log('good to go!')
                    this.ibanInvalid = false
                } else {
                    this.$store.commit(
                        'setError',
                        'IBAN length should be 24 characters long. The one you entered is ' +
                            ibanLength +
                            ' characters long'
                    )
                    this.$store.commit('setLoading', false)
                    this.ibanInvalid = true
                }
            } catch (err) {
                console.log(err)
            }
        },

        /**
         * checkIBAN
         */
        checkPhoneIsd() {
            // Check of IBAN length
            try {
                let isdCode =
                    this.$store.state.registration.form.contactInfo.isdCode
                let phoneNumber =
                    this.$store.state.registration.form.contactInfo.phoneNumber
                let resStatus =
                    this.$store.state.registration.form.basicInfo
                        .residentialStatus
                if (resStatus === '01') {
                    if (isdCode === '+92' && phoneNumber) {
                        console.log('good to go!')
                        this.phoneInvalid = false
                    } else {
                        this.$store.commit(
                            'setError',
                            'Residents can only choose +92 as the ISD with their mandatory phone number'
                        )
                        this.$store.commit('setLoading', false)
                        this.phoneInvalid = true
                    }
                } else {
                    this.phoneInvalid = false
                }
            } catch (err) {
                console.log(err)
            }
        },

        /**
         * checkIBAN
         */
        checkCountry() {
            // Check of IBAN length
            try {
                let resCountry =
                    this.$store.state.registration.form.basicInfo
                        .countryOfResidence
                let resStatus =
                    this.$store.state.registration.form.basicInfo
                        .residentialStatus
                if (resStatus === '01') {
                    if (resCountry === 'Pakistan') {
                        console.log('good to go!')
                        this.cntryInvalid = false
                    } else {
                        this.$store.commit(
                            'setError',
                            'Residents can only choose Pakistan as their Country of Residence. You have chosen ' +
                                resCountry
                        )
                        this.$store.commit('setLoading', false)
                        this.cntryInvalid = true
                    }
                } else {
                    if (resCountry === 'Pakistan') {
                        this.$store.commit(
                            'setError',
                            'Non-residents cannot choose Pakistan as their Country of Residence'
                        )
                        this.$store.commit('setLoading', false)
                        this.cntryInvalid = true
                    } else {
                        this.cntryInvalid = false
                    }
                }
            } catch (err) {
                console.log(err)
            }
        },

        /**
         * checkUIN
         */
        checkUIN() {
            // Check of IBAN length
            try {
                let uinLength =
                    this.$store.state.registration.form.identityInfo.number
                        .length
                if (uinLength === 13) {
                    console.log('good to go! UIN')
                    this.uinInvalid = false
                } else {
                    this.$store.commit(
                        'setError',
                        'UIN has to be 13 characters long. The one you entered has ' +
                            uinLength +
                            ' characters'
                    )
                    this.$store.commit('setLoading', false)
                    this.uinInvalid = true
                }
            } catch (err) {
                console.log(err)
            }
        },

        /**
         * Check Email Address
         */

        checkEmail() {
            // Check of IBAN length
            try {
                let emailAddress =
                    this.$store.state.registration.form.contactInfo.email
                let resStatus =
                    this.$store.state.registration.form.basicInfo
                        .residentialStatus
                if (resStatus === '02') {
                    if (emailAddress) {
                        console.log('good to go!')
                        this.emailInvalid = false
                    } else {
                        this.$store.commit(
                            'setError',
                            'Non-residents have to enter their e-mail address'
                        )
                        this.$store.commit('setLoading', false)
                        this.emailInvalid = true
                    }
                } else {
                    this.emailInvalid = false
                }
            } catch (err) {
                console.log(err)
            }
        },

        /**
         * Check Residential Status
         */

        checkResidentialStatus() {
            let invalidRes = ['POC', 'NICOP']
            let validRes = ['CNIC', 'SNIC']

            try {
                let resStatus =
                    this.$store.state.registration.form.basicInfo
                        .residentialStatus
                let docType =
                    this.$store.state.registration.form.identityInfo
                        .idDocumentType
                // Resident can only submit CNIC and SNIC
                console.log(resStatus)
                console.log(docType)
                if (resStatus === '01') {
                    if (validRes.includes(docType)) {
                        this.resInvalid = false
                    } else {
                        this.$store.commit(
                            'setError',
                            'Residents can only choose either CNIC or SNIC'
                        )
                        this.$store.commit('setLoading', false)
                        this.resInvalid = true
                    }
                } //non-resident
                else {
                    if (invalidRes.includes(docType)) {
                        this.resInvalid = false
                    } else {
                        this.$store.commit(
                            'setError',
                            'Non-residents can only choose either NOC or POC'
                        )
                        this.$store.commit('setLoading', false)
                        this.resInvalid = true
                    }
                }
            } catch (err) {
                console.log(err)
            }
        },

        /**
         * Check Relative Info
         */

        checkRelativeInfo() {
            let relation = ['01', '07']
            let relDict = {
                '02': "Father's",
                '03': "Mother's",
                '04': "Son's",
                '05': "Daughter's",
                '06': "Husband's",
            }
            console.log(this.fields[17])
            let relationId =
                this.$store.state.registration.form.relativeInfo.relation
            let relativesCnic =
                this.$store.state.registration.form.relativeInfo.relativesCnic
            console.log('relation: ', relationId)
            if (!relation.includes(relationId)) {
                if (relativesCnic) {
                    this.rtvInvalid = false
                } else {
                    //make relative's cnic mandatory
                    this.$store.commit(
                        'setError',
                        'Please enter your ' + relDict[relationId] + 'CNIC'
                    )
                    this.$store.commit('setLoading', false)
                    this.rtvInvalid = true
                }
            } else {
                this.rtvInvalid = false
            }
        },

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                         dataSegmentType: this.dataSegmentTypes,
                    },
                })

                this.showPageLoader = false
                this.fields = data.data
                // this.getDraftCustomer()
                console.log('Form Results: ' + JSON.stringify(data))
            } catch (error) {
                console.log('Setup-Profile-error ' + error)
            }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
    }, // End of Component > watch
} // End of export default
</script>
